<template>
  <header class="app-header">
    <div class="header-copy">
      <button class="mobile-menu" type="button" @click="$emit('menu')"><Menu :size="20" /></button>
      <div>
        <span class="eyebrow">SAFETYVISION WORKSPACE</span>
        <h1>{{ title }}</h1>
      </div>
    </div>
    <div class="header-actions">
      <div class="service-status" title="本地 API 服务状态">
        <span></span> 本地工作台
      </div>
      <button class="icon-button" type="button" title="通知"><Bell :size="18" /></button>
      <RouterLink v-if="!loggedIn" to="/login" class="header-login">登录</RouterLink>
      <div v-else class="profile-chip">
        <div class="avatar">{{ initials }}</div>
        <div>
          <strong>{{ displayName }}</strong>
          <span>{{ userCode }}</span>
        </div>
        <button type="button" title="退出登录" @click="handleLogout"><LogOut :size="16" /></button>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Bell, LogOut, Menu } from "lucide-vue-next";
import { useSession } from "../composables/session";

defineEmits(["menu"]);
const route = useRoute();
const router = useRouter();
const { loggedIn, user, logout } = useSession();

const titles = { home: "学习概览", exams: "真题题库", library: "资料库", membership: "会员权益", tools: "AI 与效率工具" };
const title = computed(() => titles[route.name] || "SafetyVision");
const displayName = computed(() => user.value?.nickname || user.value?.userName || user.value?.name || "学习用户");
const userCode = computed(() => user.value?.publicUserCode || user.value?.uid || user.value?._id || "已登录");
const initials = computed(() => String(displayName.value).slice(0, 1).toUpperCase());

function handleLogout() {
  logout();
  router.push("/login");
}
</script>
